import { render, staticRenderFns } from "./MsgHome.vue?vue&type=template&id=31765faa&scoped=true"
import script from "./MsgHome.vue?vue&type=script&lang=js"
export * from "./MsgHome.vue?vue&type=script&lang=js"
import style0 from "./MsgHome.vue?vue&type=style&index=0&id=31765faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31765faa",
  null
  
)

export default component.exports